export const API_ENDPOINT =
  (process.env.NODE_ENV as string) === "dev"
    ? "http://localhost:3001"
    : "https://inspiration-quotes.fly.dev";

export const MEETTIME_API_PATH = API_ENDPOINT + `/api/meettime`;

export const WEB_PATH = "https://wemeettime.com";
